import { Box, Paper, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LanscoButton } from '../lansco-button';

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  maxWidth: 900,
  margin: '40px auto',
  borderTop: `4px solid ${theme.palette.primary.main}`,
  borderRadius: 0,
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
  }
}));

export const Home = () => {
  const navigate = useNavigate();

  return (
    <StyledPaper elevation={3}>
      <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 300, mb: 3, color: 'primary.main' }}>
        Willkommen bei LANSCO
      </Typography>
      <Typography variant="body1" component="div" sx={{ mb: 4, lineHeight: 1.6, textAlign: 'center' }}>
        Entdecke unsere kostenlosen Ressourcen und Tools für Deine digitale Transformation.
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
        <LanscoButton
          onClick={() => navigate('/m365copilotstarterkit')}
          sx={{ minWidth: 250 }}
        >
          Microsoft 365 Copilot Starter Kit
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/ikp3m')}
          sx={{ minWidth: 250 }}
        >
          IKP3M Ressourcenpaket
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/m365securitywebinar')}
          sx={{ minWidth: 250 }}
        >
          Microsoft 365 Security Webinar
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/worldbackupday2026')}
          sx={{ minWidth: 250 }}
        >
          World Backup Day 2026 Webinar
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/sharegate/anfrage')}
          sx={{ minWidth: 250 }}
        >
          ShareGate Anfrage
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/ki-wird-mitarbeiter')}
          sx={{ minWidth: 250 }}
        >
          KI wird Mitarbeiter Webinar
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/eu-ai-act/zertifikat')}
          sx={{ minWidth: 250 }}
        >
          EU AI Act Zertifikat
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/securityservice')}
          sx={{ minWidth: 250 }}
        >
          Microsoft 365 im Blindflug?
        </LanscoButton>
        <LanscoButton
          onClick={() => navigate('/agentpulse')}
          sx={{ minWidth: 250 }}
        >
          AgentPulse – KI-Agenten sicher im Griff
        </LanscoButton>
      </Box>
    </StyledPaper>
  );
};